import { getOutcomeBadgeAppearance } from '../utils/getOutcomeBadgeAppearance'

import { CategoryOutcomeBadgeProps } from './CategoryOutcomeBadge.types'
import { Badge } from '@percent/lemonade'

export function CategoryOutcomeBadge({ label, outcome, testId }: Readonly<CategoryOutcomeBadgeProps>) {
  return (
    <Badge testId={testId} {...getOutcomeBadgeAppearance(outcome)}>
      {label}
    </Badge>
  )
}
